import { lazy, Suspense } from "react";
import { Route, Routes } from "react-router-dom";
import ErrorBoundary from "../components/ErrorBoundary";
import RouteFallback from "../components/RouteFallback";
import { MainPage } from "../pages/MainPage";

const SOP = lazy(() => import("../pages/SOP").then((m) => ({ default: m.SOP })));
const PrivacyAndPolicy = lazy(() =>
  import("../pages/PrivacyAndPolicy").then((m) => ({ default: m.PrivacyAndPolicy }))
);
const Career = lazy(() => import("../pages/Career"));
const WhatIsQargoquotePage = lazy(() =>
  import("../pages/WhatIsQargoquotePage").then((m) => ({ default: m.WhatIsQargoquotePage }))
);
const HowItWorksPage = lazy(() =>
  import("../pages/HowItWorksPage").then((m) => ({ default: m.HowItWorksPage }))
);
const ImporterPage = lazy(() =>
  import("../pages/ImporterPage").then((m) => ({ default: m.ImporterPage }))
);
const FaqsPage = lazy(() =>
  import("../pages/FaqsPage").then((m) => ({ default: m.FaqsPage }))
);
const ServiceProviderPage = lazy(() => import("../pages/ServiceProviderPage"));
const ImporterServicePage = lazy(() => import("../pages/ImporterServicePage"));
const DemoPage = lazy(() => import("../pages/DemoPage"));
const DemoImporterPage = lazy(() => import("../pages/DemoImporterPage"));
const AirCargo = lazy(() => import("../pages/AirCargo"));
const CourierFreightDetails = lazy(() => import("../pages/Courier"));
const FclDetails = lazy(() => import("../pages/FclDetails"));
const Lcldetails = lazy(() => import("../pages/Lcldetails"));
const RoroDetails = lazy(() => import("../pages/Roro"));
const Landfreight = lazy(() => import("../pages/Landfreight"));
const Ltlfreight = lazy(() => import("../pages/Ltlfreight"));
const SuccessConfirmed = lazy(() => import("../pages/SuccessConfirmed"));
const LocalShipment = lazy(() => import("../pages/LocalShipment"));

function withLanguage(Component, language) {
  return <Component language={language} />;
}

export const Allroutes = ({ language }) => {
  return (
    <ErrorBoundary fallbackTitle="Unable to load this page">
      <Suspense fallback={<RouteFallback />}>
        <Routes>
          <Route path="/" element={withLanguage(MainPage, language)} />
          <Route path="/SOP" element={withLanguage(SOP, language)} />
          <Route
            path="/privacy-policy"
            element={withLanguage(PrivacyAndPolicy, language)}
          />
          <Route path="/career" element={withLanguage(Career, language)} />
          <Route
            path="/what-is-qargoquote"
            element={withLanguage(WhatIsQargoquotePage, language)}
          />
          <Route
            path="/how-it-works-for-service-providers"
            element={withLanguage(HowItWorksPage, language)}
          />
          <Route
            path="/importer-and-trading-business-owner"
            element={withLanguage(ImporterPage, language)}
          />
          <Route path="/faqs" element={withLanguage(FaqsPage, language)} />
          <Route
            path="/service-provider"
            element={withLanguage(ServiceProviderPage, language)}
          />
          <Route
            path="/importer"
            element={withLanguage(ImporterServicePage, language)}
          />
          <Route path="/Demo" element={withLanguage(DemoPage, language)} />
          <Route
            path="/demo-importer"
            element={withLanguage(DemoImporterPage, language)}
          />
          <Route path="/air-cargo/:id" element={withLanguage(AirCargo, language)} />
          <Route
            path="/courier-freight-details/:id"
            element={withLanguage(CourierFreightDetails, language)}
          />
          <Route path="/fcl-details/:id" element={withLanguage(FclDetails, language)} />
          <Route path="/lcl-details/:id" element={withLanguage(Lcldetails, language)} />
          <Route path="/roro-details/:id" element={withLanguage(RoroDetails, language)} />
          <Route path="/land-cargo/:id" element={withLanguage(Landfreight, language)} />
          <Route path="/land-ltl/:id" element={withLanguage(Ltlfreight, language)} />
          <Route
            path="/register-success"
            element={withLanguage(SuccessConfirmed, language)}
          />
          <Route
            path="/local-shipment/:id"
            element={withLanguage(LocalShipment, language)}
          />
        </Routes>
      </Suspense>
    </ErrorBoundary>
  );
};
